import { useContext } from 'react'
import { StoreContext } from '../../store'
import Button from '@mui/material/Button'
import { withRouter } from 'react-router'
import { compose, setDisplayName } from 'react-recompose'
import { useEventTracker, useHomeIdentifier } from '../../utils/hooks'
import { EVT_CLICKED_RESERVE_HOME_BUTTON } from '../../constants/eventTracking'
import * as reducers from '../../store/reducers'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'

const ReserveButton = compose(
  withRouter,
  setDisplayName('ReserveButton')
)(({ classes, lot, loc }) => {
  const track = useEventTracker()
  const homeIdentifier = useHomeIdentifier()
  const { prospect, dispatch } = useContext(StoreContext)

  const handleAuthenticated = () => {
    dispatch(reducers.setBuyerAuthCallback()) // reset
    let url = lot.inventory.reserveHomeUrl
    window.open(url, '_blank')
  }

  const handleClick = (e) => {
    track(EVT_CLICKED_RESERVE_HOME_BUTTON, {
      lotId: lot.id,
      lotName: lot.name,
      lotAddress: lot.address,
      inventoryId: lot.inventory.id,
      homeIdentifier,
      prospectEmail: prospect ? prospect.email : null,
      loc,
    })

    if (prospect) {
      handleAuthenticated()
    } else {
      dispatch(
        reducers.setBuyerAuthCallback(handleAuthenticated),
        reducers.setBuyerLoginDialog({
          open: true,
          message: 'Please sign-in to use this feature',
        })
      )
    }
  }

  const renderButton =
    lot &&
    lot.salesStatus.trim().toLowerCase() !== 'sold' &&
    lot.inventory &&
    lot.inventory.reserveHomeUrl

  // R E N D E R
  return (
    <>
      {renderButton && (
        <Button
          className={classes}
          startIcon={<ShoppingCartIcon />}
          variant="outlined"
          color="primary"
          onClick={handleClick}
        >
          Reserve Now
        </Button>
      )}
    </>
  )
})

export const showButton = (loc, lot, buttonStyle) => {
  return <ReserveButton loc={loc} lot={lot} classes={buttonStyle.root} />
}
export default ReserveButton
